import {createFromIconfontCN} from "@ant-design/icons/lib";

const LineIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2486678_nhk1k3tehs8.js', // 在 iconfont.cn 上生成
});

export default LineIcon;
